export const BASE_WIDTH = 1280;
export const BASE_HEIGHT = 960;

const isDev = import.meta.env.DEV;

const devOriginWithPort = (port: string | number | undefined) =>
  `${window.location.protocol}//${window.location.hostname}:${port}`;

const Constants = {
  debugLog: import.meta.env.VITE_DEBUG_LOG ?? false,
  debugMode: import.meta.env.VITE_DEBUG_MODE ?? false,
  major: import.meta.env.VITE_MAJOR_VERSION,
  minor: import.meta.env.VITE_MINOR_VERSION,
  buildNumber: import.meta.env.VITE_BUILD_NUMBER,
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  // dev は vite.config.mjs の server.proxy が API へ中継するので同一オリジン（相対パス）で叩く。
  apiHost: isDev ? "" : import.meta.env.VITE_API_HOST,
  apiAuthKey: import.meta.env.VITE_API_HEADER_AUTHORIZATION_KEY,
  sentryDSN: import.meta.env.VITE_SENTRY_DSN,
  sentryEnv: import.meta.env.VITE_SENTRY_ENV,
  sentryReleasePrefix: import.meta.env.VITE_SENTRY_RELEASE_PREFIX,
  assetHost: import.meta.env.VITE_KIDS_ASSET_HOST,
  runtimeHost: isDev
    ? devOriginWithPort(import.meta.env.VITE_DEV_KIDS_RUNTIME_PORT)
    : import.meta.env.VITE_KIDS_RUNTIME_HOST,
  parentsHost: isDev
    ? devOriginWithPort(import.meta.env.VITE_DEV_PARENTS_PORT)
    : import.meta.env.VITE_PARENTS_HOST,
  parentsLinkPageHost: isDev
    ? devOriginWithPort(import.meta.env.VITE_DEV_PARENTS_LINK_PAGE_PORT)
    : import.meta.env.VITE_PARENTS_LINK_PAGE_HOST,
  kidsAppHost: import.meta.env.VITE_KIDS_APP_HOST,
  publicUrl: isDev ? window.location.origin : import.meta.env.VITE_PUBLIC_URL,
  stripeApiKey: import.meta.env.VITE_STRIPE_API_KEY,
  googleSignClientId: import.meta.env.VITE_GOOGLE_SIGN_CLIENT_ID,
  azureCVEndpoint: import.meta.env.VITE_AZURE_COMPUTER_VISION_ENDPOINT,
  azureCVKey: import.meta.env.VITE_AZURE_COMPUTER_VISION_KEY,
};

export default Constants;
